module.exports = __webpack_public_path__ + "static/media/encaminhamento-icon.f69bbff5.svg";